import ApiClientUserMixin from './ApiClientUserMixin.js';
import axios from 'axios';

export default {
  mixins: [ApiClientUserMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      selectedFileIndex: -1,
      fileViewerIsShowed: false,
    };
  },
  computed: {
    displayedFileSrc() {
      return this.fileViewerIsShowed
        ? this.files[this.selectedFileIndex].data
        : "";
    },
  },
  methods: {
    showFileViewer(index) {
      this.selectedFileIndex = index;
      this.fileViewerIsShowed = true;
    },
    hideFileViewer() {
      this.selectedFileIndex = -1;
      this.fileViewerIsShowed = false;
    },
    openFileSelector() {
      this.$refs.documentFiles.click();
    },
    hideDeleteFileModalWindow() {
      this.selectedFileIndex = -1;
      this.$refs.deleteFileModalWindow.showed = false;
    },
    showDeleteFileModalWindow(fileIndex) {
      this.selectedFileIndex = fileIndex;
      this.$refs.deleteFileModalWindow.showed = true;
    },
    deleteFile(index) {
      this.hideDeleteFileModalWindow();
      this.hideFileViewer();
      let deleted = this.files.splice(index, 1);
      this.$emit("images-deleted", deleted);
    },
    saveUploadedFiles() {
      this.$emit("uploading-started");

      let rendered = [];

      if (this.files.length > 0) {
        this.files.forEach(file => {
          rendered.push({ 
            name: file.name, 
            data: file.data, 
            id: file.id, 
            isPdf: file.isPdf,
            isLoading: false
           });
        });
      }

      let files = Array.from(this.$refs.documentFiles.files);
      let targetFilesCount = rendered.length + files.length;
      let component = this;
      files.forEach((file) => {
        if (!file || !/\.(pdf|jpe?g|png)$/i.test(file.name))
          return;

        let reader = new FileReader();
        reader.addEventListener("load", function () {
          let newFile = {
            name: file.name,
            data: reader.result,
            isPdf: /\.(pdf)$/i.test(file.name),
            isLoading: false
          };
          component.files.push(newFile);
          rendered.push(newFile);
          if (component.files.length === targetFilesCount) {
            component.$emit("files-uploaded", component.type, component.files);
          }
        });
        
        reader.readAsDataURL(file);
      });

      this.$refs.documentFiles.value = "";
    },
    selectNextStep() {
      this.$emit("select-next-step");
    },
    loadPdf(images) {

      if (images.length === 0)
        return;

      let component = this;

      images.forEach((image, index) => {
        image.name += `_${index + 1}`;
        image.isLoading = true;
        axios.get(`${component.baseUrl}/images/${image.id}`, {
          headers: { authorization: component.token },
          responseType: 'arraybuffer'
        }).then(result => {
          var buffer = Buffer.from(Buffer.from(result.data, 'binary'));
          image.data = 'data:image/jpeg;base64,' + buffer.toString('base64');
        }).finally(() => {
          image.isLoading = false;
          component.$emit("pdf-rendered", images);
        })});
      }
  },
}